<template>
  <div id="app">
    <div id="wrapper">
      <div class="content-page">
        <div class="content">
          <div class="container-fluid">
            <div class="page-wrapper mt-3">
              <left-sidebar v-if="isAuthenticated()" />

              <div
                class="page-content"
                :class="[isAuthenticated() ? 'menu-margin-left' : 'menu-no-margin-left']"
              >
                <router-view />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .menu-margin-left {
    margin-left: 240px;
  }

  .menu-margin-bottom {
    margin-bottom: 44px;
  }

  .menu-no-margin-left {
    margin-left: 0px;
  }

  .menu-no-margin-bottom {
    margin-bottom: 30px;
  }
</style>

<script>
import { mapGetters } from "vuex";
import * as moment 		from "moment";

import { AUTH_LOGOUT } 	from "@/store/types";
import { toastMessage } from "@/services/utils";
import LeftSidebar      from "@/components/LeftSidebar/";

const signOut = function () {
	this.$store.dispatch(AUTH_LOGOUT)
		.then(() => {
			this.$router.push("/session");
		});
};

const sessionWatcher = function () {		
	const { lastSignedAt }  = this.$store.state;
	const currentTime       = moment();
	const notifTime 	      = moment(lastSignedAt).add(1435, "minutes"); // 23 hours and 55 minutes
	const signOutTime       = moment(lastSignedAt).add(1440, "minutes"); // 24 hours

	if (lastSignedAt) {
		setTimeout(() => {
			toastMessage("Votre session arrive bientôt à expiration, vous allez être déconnecter !", 6000);
		}, notifTime.diff(currentTime));

		setTimeout(() => {
			toastMessage("Votre session à expirer, merci de vous reconnecter !", 6000);
			signOut.bind(this)();
		}, signOutTime.diff(currentTime));
	}
};

export default {
	name: "App",
	components: { LeftSidebar },
	watch: {
		"$store.state.lastSignedAt": "sessionWatcher"
	},
	mounted() {
		this.sessionWatcher();
	},
	methods: {
		sessionWatcher,
		...mapGetters(["isAuthenticated"])
	}
};
</script>